module.exports = __webpack_public_path__ + "img/planta_baixa_02.254638e1.jpeg";